"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Handler_1 = __importDefault(require("./Handler"));
var constant_1 = require("../constant");
var utils_1 = require("../utils");
var aliImageUrlRegex1 = /(?:(?:taobaocdn)|(?:alicdn))\.com(?:(?:[\w\W]+item_pic)|(?:\/bao\/uploaded[\w\W]+)|(?:\/imgextra[\w\W]+)|(?:\/img[\w\W]+))\.(?:webp|jpg|png|SS2)$/i;
var aliImageUrlRegex2 = /(?:(?:taobaocdn)|(?:alicdn))\.com(?:(?:\/img[\w\W]+))\.(?:webp|jpg|png)$/i;
var AliImage = (function (_super) {
    __extends(AliImage, _super);
    function AliImage(imageUrl, imageProps) {
        var _this = _super.call(this, imageUrl, imageProps) || this;
        _this.name = "Ali";
        _this.imageProps = imageProps;
        _this.imageUrl = imageUrl;
        _this.originSrc = imageUrl;
        return _this;
    }
    AliImage.prototype.getCompatibleImageUrl = function () {
        var imageUrl = this.compatibleImageUrl;
        return this.transferAlisize(imageUrl, this.imageProps);
    };
    AliImage.prototype.makeImageUrls = function () {
        var sourceWithWebpAndSize = "", sourceWithJpgAndSize = "", sourceWithWebp = "", sourceWithJpg = "";
        var src = this.getCompatibleImageUrl();
        if (aliImageUrlRegex1.test(src)) {
            if (src.endsWith(".webp")) {
                sourceWithWebpAndSize = src;
                sourceWithWebp = src.replace(/_(?:\d+)x(?:\d+)(?:[\w\d]*)\.(?:webp)$/, "_.webp");
            }
            sourceWithJpgAndSize = src.replace(/\_\.(webp)$/, ".jpg");
            sourceWithJpg = src.replace(/_(\d+)x(?:\d+)(?:\_?)\.(?:jpg|png|gif|webp)$/, "");
        }
        return utils_1.dropEmptyValue([
            sourceWithWebpAndSize,
            sourceWithWebp,
            sourceWithJpgAndSize,
            sourceWithJpg,
            this.originSrc === sourceWithJpg ? "" : this.originSrc
        ]);
    };
    AliImage.prototype.transferWebp = function (src) {
        if (aliImageUrlRegex2.test(src)) {
            return ".webp";
        }
        return "_.webp";
    };
    AliImage.prototype.transferAlisize = function (imageUrl, imageProps) {
        var suffix = utils_1.isSupportWebP ? this.transferWebp(imageUrl) : ".jpg";
        var aliImageUrlWithQueryRegex = /_(\d+)x\1([\w\d]*)\.(jpg|png|gif)$/;
        imageUrl = imageUrl.replace(/_\.webp$/i, "");
        var RImgUrl = imageUrl, originSize = "", aliSize, qnParams = {}, keepSize = false;
        if (typeof imageProps === "number") {
            aliSize = imageProps;
        }
        if (typeof imageProps === "object") {
            aliSize = imageProps.aliSize || 0;
            keepSize = imageProps.keepSize || false;
            qnParams = imageProps.qnParams || {};
        }
        qnParams = __assign({}, qnParams);
        if (aliImageUrlRegex1.test(imageUrl)) {
            var result = aliImageUrlWithQueryRegex.exec(imageUrl);
            if (result !== null) {
                imageUrl = imageUrl.replace(result[0], "");
                originSize = result[1];
            }
            if (typeof qnParams === "object" && (qnParams.w || qnParams.h)) {
                if (keepSize === true) {
                    qnParams.w = utils_1.transferTens(qnParams.w || qnParams.h);
                    qnParams.h = utils_1.transferTens(qnParams.h || qnParams.w);
                }
                else {
                    var cw = (qnParams.w || qnParams.h) || 0;
                    var ch = (qnParams.h || qnParams.w) || 0;
                    qnParams.w = utils_1.transferTens(cw * constant_1.DevicePixelRatio);
                    qnParams.h = utils_1.transferTens(ch * constant_1.DevicePixelRatio);
                }
                RImgUrl = imageUrl + "_" + qnParams.w + "x" + qnParams.h + suffix;
            }
            else if (aliSize) {
                if (keepSize === true) {
                    aliSize = aliSize * 100;
                }
                else {
                    aliSize = aliSize * constant_1.DevicePixelRatio * 100;
                }
                RImgUrl = imageUrl + "_" + aliSize + "x" + aliSize + suffix;
            }
            else if (originSize) {
                RImgUrl = imageUrl + "_" + originSize + "x" + originSize + suffix;
            }
        }
        return RImgUrl;
    };
    AliImage.match = function (src) {
        return aliImageUrlRegex1.test(src);
    };
    return AliImage;
}(Handler_1.default));
exports.default = AliImage;
